<template>
  <v-row no-gutters>
    <v-col
      v-for="(item, index) in items"
      :key="index"
      cols="12"
      :class="{ 'mb-12': !isBannerVisible(index) && index + 1 !== items.length }"
    >
      <v-sheet
        class="py-3 border-md border-t-lg border-opacity-25"
      >
        <v-row no-gutters>
          <v-col
            cols="12"
            class="px-3 order-1 order-md-0"
          >
            <TagCustom
              v-for="(criteria, criteriaIndex) in criteriaList(item)"
              :key="criteriaIndex"
              :text="criteria"
            />
          </v-col>
          <v-col
            cols="12"
            class="px-5 pb-2 mt-1 mb-4 mb-md-0 border-bottom order-0 order-md-1"
          >
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="6"
              >
                <p class="f-20 sz-primary-grey--text font-weight-medium mb-0">
                  {{ familyTitle(item.familyMembers) }}
                </p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="text-sm-right"
              >
                <p class="f-20 sz-primary-grey--text font-weight-medium mb-0">
                  <span class="f-14 sz-secondary-grey--text font-weight-regular mr-1">
                    {{ $t('label.warehouse') }}:
                  </span>
                  {{ item.warehouse.name }}
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="px-5 mt-3 order-2"
          >
            <MembersComponent :list="item.familyMembers" />
            <div class="mt-3 border-bottom" />
          </v-col>
          <v-col
            cols="12"
            class="px-5 mt-3 order-3"
          >
            <ReadMoreText
              :key="item.familyEditionId"
              :text="item.sheet.description.familyHistory"
            />
          </v-col>
          <v-col
            cols="12"
            class="px-5 mt-3 font-weight-medium sz-primary-grey--text order-4"
          >
            <p class="mb-0 f-18">
              {{ $t('familiesList.importantNeeds') }}: {{ importantNeeds(item.importantNeeds) }}
            </p>
          </v-col>
          <v-col
            cols="12"
            class="mt-3 px-5 py-3 order-5"
          >
            <v-row
              no-gutters
              justify="center"
              justify-md="end"
            >
              <v-col cols="auto">
                <router-link
                  :to="{
                    name: ROUTE_NAMES.FAMILY,
                    params: routerParams(item)
                  }"
                  class="primary-button"
                >
                  {{ $t('label.showDetails') }}
                </router-link>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
      <BannerBox
        v-if="isBannerVisible(index)"
        v-bind="$tm('banners.SzPListBanner')"
        class="mt-12 mb-8"
        color="sz-white"
      />
    </v-col>
  </v-row>
</template>

<script>
import MembersComponent from '@/components/FamiliesList/MembersComponent';
import ReadMoreText from '@/components/FamiliesList/ReadMoreText';
import BannerBox from '@/components/widgets/BannerBox/BannerBox.vue';
import TagCustom from '@/components/widgets/TagCustom';
import ROUTE_NAMES from '@/constants/routeNames';

export default {
    name: 'ListComponent',
    components: { BannerBox, ReadMoreText, TagCustom, MembersComponent },
    props: {
        items: {
            required: true,
            type: Array
        }
    },
    data () {
        return {
            ROUTE_NAMES
        };
    },
    computed: {
        bubbleId () {
            return this.$store.getters['families/getBubbleId'];
        },
        bubbleName () {
            return this.$store.getters['families/getBubbleName'];
        },
        provinceId () {
            return this.$store.getters['provinces/getCurrentProvinceId'];
        },
        provinceName () {
            return this.$store.getters['provinces/getCurrentProvinceName'];
        }
    },
    methods: {
        criteriaList (item) {
            if (item.hasGreaterNeeds === true) {
                return item.helpCriteria.concat([this.$t('label.greaterNeeds')]);
            }
            return item.helpCriteria;
        },
        importantNeeds (needs) {
            const list = Array.from(needs.list, x => x.need);
            return list.join(', ');
        },
        familyTitle (members) {
            if (members.length > 0) {
                const firstMember = members[0].relationName + ' ' + members[0].newName;
                return members.length > 1 ? firstMember + ' ' + this.$t('familiesList.withFamily') : firstMember;
            }
            return '';
        },
        isBannerVisible (index) {
            return this.items.length >= 5 && index === 2;
        },
        routerParams (item) {
            return {
                familyEditionId: item.familyEditionId,
                warehouseId: item.warehouse.id,
                ga: {
                    bubbleId: this.bubbleId,
                    familyWarehouse: this.bubbleName,
                    provinceId: this.provinceId,
                    provinceName: this.provinceName
                }
            };
        }
    }
};
</script>

<style scoped></style>
